import React, {Component, Text, Button} from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import * as Constants from "../utils/constants";
import * as RequestAccess from "../service/access-control/requestsAccess.js";
import {Redirect} from 'react-router'
import * as DataService from "../service/data-info-chart/requestsUtil";
import imageStratiMex from '../resources/images/estrategas/logo.jpg'
import Loader from 'react-loader';


class Login extends Component {

  _userLogin = () => {
    this.setState({loader: false})
    let params = {
      account: this.refs.username.getValue(),
      password: this.refs.password.getValue()
    };

    RequestAccess.getFetch(Constants.LOG_IN, Constants.METHOD.POST, params)
      .then((status) => {
        if (status === 200) {
          DataService.getFetch(Constants.GET_INFO_ROL)
            .then((data) => {
              let dataUser = new RequestAccess.DataUser(data.roleName, data.profile, data.nameBusinessUnit, data.businessUnit, data.account);
              localStorage.setItem("userData", JSON.stringify(dataUser));
              this.setState({isLoggingIn: true, message: "", url: dataUser.rol, bu: dataUser.businessUnit, loader: true});
            });
        } else {
          this.setState({isLoggingIn: false, message: "Usuario no registrado", loader: true});
        }
      });
  };
  clearUsername = () => {
    this._username.setNativeProps({text: ''});
    this.setState({message: ''});
  };
  clearPassword = () => {
    this._password.setNativeProps({text: ''});
    this.setState({message: ''});
  };

  constructor(props) {
    super(props);
    this.keyPress = this.keyPress.bind(this);
    this.state = {
      isLoggingIn: false,
      url: '/',
      bu: '',
      message: '',
      loader: true
    }
  }

  keyPress(e){
    if(e.keyCode === 13){
      this._userLogin();
    }
  }

  render() {
    var login = <div className="login-wrapper">
      <div className="login-fields">
        <div className="content-image-banner-primary">
          <img src={imageStratiMex} alt="Estrategas de México" className="image-banner-primary"/>
        </div>
        <h3>Iniciar sesión</h3>
        <TextField
          ref="username"
          floatingLabelText="Usuario"
          fullWidth={true}
          autoFocus={true}
          onKeyDown={this.keyPress}
        />
        <TextField
          ref="password"
          floatingLabelText="Contraseña"
          type="password"
          fullWidth={true}
          onKeyDown={this.keyPress}
        />
        {this.state.message}
        <div className="pt20">
          <RaisedButton onClick={this._userLogin} label="Ingresar" primary={true} fullWidth={true}/>
        </div>
        <Loader loaded={this.state.loader}/>
      </div>
    </div>;
    var result = "";
    if (this.state.isLoggingIn) {
      if (this.state.url === Constants.ROL.CLIENT.url) {
        // result = <Redirect to={Constants.ROL_URL.CLIENT_GIS + this.state.bu}/>
        result = login;
      } else if (this.state.url === Constants.ROL.MANAGEMENT.url) {
        result = <Redirect to={Constants.ROL_URL.MANAGEMENT + this.state.bu}/>
      } else if (this.state.url === Constants.ROL.SUPERVISOR.url) {
        result = <Redirect to={Constants.ROL_URL.SUPERVISOR + this.state.bu}/>
      } else {
        result = <Redirect to={this.state.url}/>
      }
    } else {
      result = login;
    }
    return (
      <div>
        {result}
      </div>
    )
  }
};

export default Login;



// WEBPACK FOOTER //
// ./src/containers/login.js